<template lang="pug">
div
  b-button.float-right(type='button', disabled, variant='danger' v-if='loading')
    i.fa.fa-refresh.fa-spin
    | &nbsp;Loading
  b-button.float-right(style='color: white', type='button', variant='link' @click='showModalXlsx = true', v-else-if='(data == "total")')
    | Date Selection
  b-button.float-right(type='button', variant='outline-primary', @click='showModalXlsx = true', v-else)
    | Date Selection
  b-button.float-right.mr-2(type='button', variant='success', v-if='refreshNeeded && (data == "customer" || data == "crm")', @click='refresh')
    | Data updated, please refresh
  b-modal(v-model='showModalXlsx', title='Date Selection', @shown='clearError', lazy)
    b-btn-group.w-100
      b-button.btn-block(type='button',variant='outline-primary', @click='setWeek()')
          | &nbsp;Last 7 days
      b-button.btn-block(type='button',variant='outline-primary', @click='setMonth()')
          | &nbsp;Last 30 days
    br
    br
    h4.card-title.mb-0(style='color: red;', v-if='errorDate')
      | &nbsp;Invalid input date
    br(v-if='errorDate')
    b-row
      b-col(sm='3')
        h6.card-title.mb-0
          | Start:&nbsp;
      b-col(sm='9')
        b-form-input(type='date', size='sm', id='startDate', min="2018-03-22")
    br
    b-row
      b-col(sm='3')
        h6.card-title.mb-0
          | End:&nbsp;
      b-col(sm='9')
        b-form-input(type='date', size='sm', id='endDate', min="2018-03-22")
    br
    b-form-checkbox(id='smalltalk', v-if='data == "intent"', v-model='includesmalltalk', value='true', unchecked-value='false')
      |Include Small Talk
    div(slot='modal-footer')
      b-button.float-right.ml-1(type='button', variant='outline-primary', @click='showModalXlsx = false; errorDate = false')
        | Cancel
      b-button.float-right.ml-1(@click='drawGraphAsDate', variant='primary')
        | Show Graph

</template>
<script>
// import { downloadReport, exportReportAnalytic } from '@/api'
// import { ecp, ecrmp, eip, etp } from '@/jsonToXlsx'
import { db } from '@/firebase'

const anaRef = db.ref('analytics')
export default {
  name: 'app-dateselection',
  data() {
    return {
      includesmalltalk: false,
      showModalXlsx: false,
      errorDate: false,
    }
  },
  props: {
    userAccessLevel: String,
    data: String,
    bot: String,
    loading: false,
  },
  computed: {
    bot: function() {
      return this.botProp || this.$store.state.bot
    },
    refreshNeeded: function() {
      return this.$store.getters.getRefreshNeeded
    },
  },
  methods: {
    drawGraphAsDate: function() {
      const that = this
      var startDate = document.getElementById('startDate').value
      var endDate = document.getElementById('endDate').value
      var sDate = this.formatDateSpace(new Date(startDate))
      var eDate = this.formatDateSpace(new Date(endDate))
      var singDate = new Date(startDate)
      var eingDate = new Date(endDate)
      var dayDifference = ((eingDate - singDate) / (24 * 60 * 60 * 1000))
      if (!document.getElementById('startDate').value || !document.getElementById('endDate').value) {
        that.errorDate = true
      } else if (startDate > endDate) {
        that.errorDate = true
      } else if (dayDifference > 31) {
        that.errorDate = true
      } else {
        this.showModalXlsx = false
        let startToCount = false
        var labels
        var data
        var data1
        var noOfDay
        var noOfDay1
        labels = []
        data = []
        data1 = []
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        anaRef.child('daily').once('value', (snapshot) => {
          Object.entries(snapshot.val()).forEach(
            function([key, val]) {
              if (key === sDate) {
                startToCount = true
              }
              if (startToCount === true) {
                var DD = key.substring(6, 8)
                var MM = key.substring(4, 6)
                var MMName = monthNames[parseInt(MM) - 1]
                labels.push(DD + '/' + MMName)
                noOfDay = val.totals.users.total
                data.push(noOfDay)
                noOfDay1 = val.totals.interactions.total
                data1.push(noOfDay1)
              }
              if (key === eDate) {
                startToCount = false
              }
            }
          )
          /* that.graphLabels = labels
          that.userData = data
          that.interactionsData = data1 */
          var graphData = {
            graphLabels: labels,
            userData: data,
            interactionsData: data1,
            timestamp: new Date(),
          }
          sDate = this.formatDate(new Date(startDate))
          eDate = this.formatDate(new Date(endDate))
          var startEndDate = {
            startingDate: sDate,
            endingDate: eDate,
          }
          var graphStatus = 'selectionDays'
          that.$store.dispatch('setGraphStatus', graphStatus)
          that.$store.dispatch('setStartEndDate', startEndDate)
          that.$store.dispatch('setGraphData', graphData)
        })
      }
    },
    testing: function() {
      var d = new Date(document.getElementById('startDate').value)
      d.setHours(d.getHours() - 8)
      // d.setHours(d.getHours() - 8)
      console.log(d)
    },
    setWeek: function() {
      document.getElementById('endDate').value = this.formatDate(new Date())
      var d = new Date()
      d.setDate(d.getDate() - 7)
      document.getElementById('startDate').value = this.formatDate(d)
    },
    setMonth: function() {
      document.getElementById('endDate').value = this.formatDate(new Date())
      var minimumDate = new Date('March 22, 2018')
      var d = new Date()
      d.setDate(d.getDate() - 30)
      if (d <= minimumDate) {
        d = minimumDate
      }
      document.getElementById('startDate').value = this.formatDate(d)
    },
    clearError: function() {
      this.errorDate = false
    },
    formatDate: function(date) {
      var d = new Date(date)
      var month = '' + (d.getMonth() + 1)
      var day = '' + d.getDate()
      var year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day
      return [year, month, day].join('-')
    },
    formatDateSpace: function(date) {
      var d = new Date(date)
      var month = '' + (d.getMonth() + 1)
      var day = '' + d.getDate()
      var year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day
      return [year, month, day].join('')
    },
    refresh: function() {
      this.$store.dispatch('setRefresh', true)
      this.$store.dispatch('setRefreshNeeded', false)
    },
  },
  beforeDestroy: function() {
    this.$store.dispatch('setRefreshNeeded', false)
  },
}
</script>



// WEBPACK FOOTER //
// src/components/DateSelection.vue?66c54466